/* A single preference; native radio groups remain keyboard accessible. */
(function(){
 'use strict';
 var appearance=window.MetAppearance;if(!appearance)return;
 var groups=Array.from(document.querySelectorAll('[data-appearance-controls]'));
 function sync(){groups.forEach(function(group){group.querySelectorAll('input[type="radio"]').forEach(function(input){input.checked=input.value===appearance.get();});});}
 groups.forEach(function(group){group.hidden=false;group.addEventListener('change',function(event){if(event.target.matches('input[type="radio"]'))appearance.set(event.target.value);});});
 window.addEventListener('met:appearance-change',sync);sync();
})();
